module.exports = __webpack_public_path__ + "files/61dc78706465ab021150cb0f7aaba3c2.png";